import { http } from "./http";
import { getPaginationRequestParams } from "../utils/paginationRequest";

export function getMembershipPrints(pagination) {
    return http.get(`v1/membership-prints?${getPaginationRequestParams(pagination)}`);
}

export function deleteMembershipPrint(id) {
    return http.delete(`v1/membership-prints/${id}`);
}

export function createMembershipPrint(mp) {
    return http.post(`v1/membership-prints`, {...mp});
}

export function updateMembershipPrint(mp, id) {
    return http.patch(`v1/membership-prints/${id}`, {...mp});
}

export function getMembershipPrint(id) {
    return http.get(`v1/membership-prints/${id}`);
}

export function exportMPToXLSX(mpId) {
    return http.post(`/v1/membership-prints/export/${mpId}`, {}, { responseType: "blob" });
}

export function getNextCode(referenceYear) {
    return http.get(`/v1/membership-prints/code/next?referenceYear=${referenceYear}`);
}

export function fromFormToPayload(obj, originalMbs) {
    const mergedMbs = (obj.memberships ?? [])
        .filter((mb) => !originalMbs.find((originalMb) => originalMb.id === mb.id))
        .map((mb) => ({ id: mb.id }));

    mergedMbs.push(
        ...originalMbs.filter(originalMb => {
            return !(obj.memberships ?? []).find((mb) => mb.id === originalMb.id);
        }).map((mb) => ({ id: mb.id, toBeDisconnected: true }))
    );

    return {
        ...obj,
        memberships: mergedMbs,
    }
}